import React, { useEffect, useState } from 'react';
import type { ProSettings } from '@ant-design/pro-components';
import { PageContainer, ProCard, ProLayout } from '@ant-design/pro-components';
import { Drawer, message, Tooltip, Space } from 'antd';
import { IdcardOutlined, PoweroffOutlined, DatabaseOutlined, HomeOutlined, ToolOutlined, DesktopOutlined } from '@ant-design/icons';
import { Outlet, useNavigate } from 'react-router-dom';
import { Zja } from './_kzj';
import Apay from './_pay';
import Rzdh from './_rzcsdh';
import Sqdh from './_sqdh';
import Uapsw from './_unpsw';

import { hnrequest, removeTokenhn } from '../../utils/index';


const Aqymb = () => {

  const [messageApi, contextHolder] = message.useMessage();
  const [ticks, setticks] = useState([]);// 更新参数
  const navigate = useNavigate()
  const [uname, setUname] = useState([]);
  const [bangm, setBangm] = useState([]);



  // 安全退出
  const onConfirm = () => { localStorage.removeItem('hntoken_key'); navigate('/'); }


  const bjztq = { smsg1: 'success', smsg2: 'false' }
  useEffect(() => {
    async function getau() {
      const resg: any = await hnrequest.get('/authalpha')
      const bjzt = resg.return_code
      if (bjzt === bjztq.smsg2) {
        messageApi.open({ type: 'error', content: '登录超时', }); removeTokenhn();

        return setTimeout(() => { navigate('/') }, 1000)
      }
      setBangm(resg.ujson[0])
      setUname(resg.ujson[0].u_name)
    }
    getau()
  }, [bjztq.smsg2, bjztq.smsg1, navigate, messageApi, ticks])

  const defaultProps = {
    route: {
      path: '/hn',
      routes: [
        {
          path: '/hn',
          name: '欢迎',
          icon: <HomeOutlined />,
          component: './hn',
        },
        {
          path: 'hn/pdt',
          name: '生产数据资料',
          icon: <DatabaseOutlined />,
          component: './hn',
          routes: [

            {
              path: 'plist',
              name: '产品列表',
              component: './hn',
            },
             {
              path: 'qymb',
              name: '企业模板',
              component: './hn',
            },

            {
              path: 'redb',
              name: '近日数据',
              component: './hn',
            },
            {
              path: 'adb',
              name: '全部数据',
              component: './hn',
            },

            {
              path: 'nybz',
              name: '农药标注',
              component: './hn',
            },

            {
              path: 'dbdel',
              name: '回收站',
              component: './hn',
            },
          ],
        },
        {
          path: 'hn/dbxf',
          name: '数据修复',
          icon: <ToolOutlined />,
          component: './hn',
          routes: [
            {
              path: 'dbhf',
              name: '产品列表',
              component: './hn',
            },
            {
              path: 'dbhflist',
              name: '恢复记录',
              component: './hn',
            },
            {
              path: 'dbqq',
              name: '数据强取',
              component: './hn',
            },
          ],
        },
        {
          name: '用户管理中心',
          icon: <DesktopOutlined />,
          path: 'hn/uc',
          component: './hn',
          routes: [
            {
              path: 'un',
              name: '账号信息',
              component: './hn',
              routes: [
                {
                  path: 'intro',
                  name: '企业介绍(通用)',
                  component: './hn',
                },
                {
                  path: 'uname',
                  name: '实名认证',
                  component: './hn',
                },
                {
                  path: 'uasef',
                  name: '账号安全',
                  component: './hn',
                },
                {
                  path: 'uauth',
                  name: '身份与权限',
                  component: './hn',
                },
                {
                  path: 'usa',
                  name: '子账号管理',
                  component: './hn',
                },
                {
                  path: 'authmg',
                  name: '授权管理',
                  component: './hn',
                },
              ],
            },
            {
              path: 'oai',
              name: '订单与发票',
              component: './hn',
              routes: [
                {
                  path: 'cz',
                  name: '充值记录',
                  component: './hn',
                },
                {
                  path: 'xf',
                  name: '消费记录',
                  component: './hn',
                },
                {
                  path: 'sqrz',
                  name: '胜券日志',
                  component: './hn',
                },
                {
                  path: 'kp',
                  name: '开票记录',
                  component: './hn',
                },
              ],
            },
            {
              path: 'aap',
              name: '地址和联系人',
              component: './hn',
            },
          ],
        },

      ],
    },
    appList: [
      {
        icon: 'https://shengcong.sh3.ikuai7.com/ap_res/v3/1000_1765642573#sc',
        title: 'Sheng Cong Wang ',
        desc: '胜聪网-可信链 备用',
        url: 'http://www.ddspp.com',
        target: '_blank',//可注释
      },

    ],
  };
  ////////////////////菜单配置end



  const settings = useState<Partial<ProSettings> | undefined>({ layout: 'side', });
  const [pathname, setPathname] = useState('/v3');
  //////////////////////////////
  const [open, setOpen] = useState(false);

  const [openzf, setOpenzf] = useState(false);
  const [openrz, setOpenrz] = useState(false);
  const [opensq, setOpensq] = useState(false);
  const [openup, setOpenup] = useState(false);





  const showLargeDrawer = () => { setOpen(true) }
  const onClose = () => { setOpen(false) }
  const setHticks = (msg: any) => {
    setticks(msg)
    setOpenzf(false)
    setOpenrz(false)
    setOpensq(false)
    setOpenup(false)
  }
  const gbAll = () => {
    setOpenzf(false)
    setOpenrz(false)
    setOpensq(false)
    setOpenup(false)
  }
  const uTest = (k: string) => {
    gbAll()
    k === "chongzhi" && setOpenzf(true)
    k === "renzheng" && setOpenrz(true)
    k === "shengquandh" && setOpensq(true)
    k === "chuna_psw" && setOpenup(true)


  }


  return (<>
    {contextHolder}
    <div
      style={{
        height: '100vh',
      }}
    >

      <ProLayout
        title="胜聪数字化中心"
        logo="https://shengcong.sh3.ikuai7.com/ap_res/v3/1000_1765642573#sc"
        siderWidth={256}

        {...defaultProps}
        location={{
          pathname,
        }}
        menu={{
          type: 'group',
        }}
        avatarProps={{
          src: <IdcardOutlined style={{ color: '#434343' }} onClick={showLargeDrawer} />,
          title: <div onClick={showLargeDrawer} style={{ minWidth: '150px' }}>{uname} </div>,
        }}

        menuItemRender={(item, dom) => (
          <div
            onClick={() => {
              const sedpath: any = item.path
              setPathname(item.path || '/v3');
              navigate(sedpath);
              // console.log(item.name,sedpath)
            }}
          >
            {dom}
          </div>
        )}
        {...settings}
      >
        <PageContainer header={{ title: false }}  >
          <ProCard
            style={{
              height: '100vh',
              minHeight: 800,
            }}
          >
            <Outlet context={uTest}></Outlet>


          </ProCard>
        </PageContainer>
      </ProLayout>








      <Drawer
        title="账号信息"
        placement="right"
        size="large"
        closeIcon={false}
        onClose={onClose}
        className='zhxx'
        open={open}

        extra={
          <Space>
            <Tooltip placement="top" title='安全退出' ><PoweroffOutlined key="PoweroffOutlined" onClick={onConfirm} />
            </Tooltip>
          </Space>
        }

      >

        <Zja jname={bangm} onuTest={uTest} />

        {openzf && <Apay onsetHticks={setHticks} />}
        {openrz && <Rzdh onsetHticks={setHticks} />}
        {opensq && <Sqdh onsetHticks={setHticks} />}
        {/* yh修改 密码修改 */}
        {openup && <Uapsw oncpsw={onConfirm} />}



      </Drawer>




    </div>
  </>
  );
};

export default Aqymb;